type StoreRedirectWindowApplicantIdAction = {
	type: 'STORE_REDIRECT_WINDOW_APPLICANT_ID'
}

type ClearRedirectWindowApplicantIdAction = {
	type: 'CLEAR_REDIRECT_WINDOW_APPLICANT_ID'
}

export function storeRedirectWindowApplicantId(): StoreRedirectWindowApplicantIdAction {
	return {
		type: 'STORE_REDIRECT_WINDOW_APPLICANT_ID',
	}
}
export function clearRedirectWindowApplicantId(): ClearRedirectWindowApplicantIdAction {
	return {
		type: 'CLEAR_REDIRECT_WINDOW_APPLICANT_ID',
	}
}
